/* eslint-disable no-unused-vars */
/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  getSearchHistories({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .get(`search-histories?${new URLSearchParams(param)}`)
        .then((response) => {
          const data = response.data?.data?.items || [];
          commit("SET_SEARCH_HISTORIES", data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  addNewHistory({ commit }, history) {
    return new Promise((resolve, reject) => {
      axios
        .post("search-histories", history)
        .then((response) => {
          commit("ADD_HISTORY", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  deleteHistory({ commit }, historyId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`search-histories/${historyId}`)
        .then((response) => {
          commit("REMOVE_HISTORY", historyId);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getStudentFilter({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .get(`search-histories?${new URLSearchParams(param)}`)
        .then((response) => {
          const data = response.data.data;
          commit("SET_STUDENT_FILTER", data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getStudentFilterByType({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .get("search-histories-filter-type", { params: param })
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  addStudentFilter({ commit }, history) {
    return new Promise((resolve, reject) => {
      axios
        .post("search-histories", history)
        .then((response) => {
          commit("ADD_STUDENT_FILTER", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateStudentFilter({ commit }, { historyId, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`search-histories/${historyId}`, payload)
        .then((response) => {
          commit("UPDATE_STUDENT_FILTER", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },

  deleteMultipleStudentFilter({ commit }, ids) {
    return new Promise((resolve, reject) => {
      axios
        .post("search-histories/delete-multiple", ids)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
